<template>
  <div class="ele-wrap">
    <resize-container :tabShow="tabShow">
      <div class="grid-content" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @changeCompany="changeCompany" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick"></tab-tree>
      </div>
      <div class="grid-rightcontent">
        <btn-show @show="Btn" content="左边树"></btn-show>
        <div class="middle ">
          <el-row :gutter="14" class="flexStyle">
            <el-col :span="24" style="border-radius: 4px;" class="flexStyle">
              <State :tableData="tableData" :volatgePass="volatgePass" :frquencyPass="frquencyPass" :ifLoad="ifLoad"></State>
            </el-col>
          </el-row>
        </div>
        <div class="bottom">
          <el-row :gutter="14" class="flexStyle">
            <el-col :span="24" class="flexStyle">
              <real-timep :selectedMeasure="selectedMeasure"></real-timep>
            </el-col>
          </el-row>
        </div>
      </div>
    </resize-container>
  </div>
</template>

<script>
import elementResizeDetectorMaker from 'element-resize-detector'
import TabTree from '@/components/common/TabTree.vue'
import BtnShow from '@/components/common/BtnShow.vue'
import { isNull, isUndefined } from "util";
import api from '@common/api/index.js'
import { findDataByParam } from '@/utils/index.js'
import handleData from '@/utils/handleData.js'
import State from '@/components/page/eleDeviation/State.vue'
import RealTimep from '@/components/page/eleDeviation/RealTimep.vue'
import ResizeContainer from "@/components/common/resizeContainer.vue";
export default {
  name: 'eleDeviation',
  // 引用组件
  components: { TabTree, BtnShow, State, RealTimep, ResizeContainer },
  data () {
    return {
      topcontent: false,
      tabShow: true,
      tableData: [],
      viewTreeData: [],
      selectedMeasure: {
        measureId: '',
        measureName: ''
      },
      ifQualified: '',
      ifLoad: true,
      deviation: [], //频率因数
      deviationTilte: '频率偏差',
      power: [], //功率因数
      powerTitle: '功率因数',
      frequency: {},
      frquencyPass: '',
      volatgePass: '',
    }
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  created () {
    let vm = this
    vm.selectedTab = 'voltage'
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () {
  },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {},
  // 方法定义
  methods: {
    changeCompany (companyId) {
      api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, '/power/eleDeviation', null)
        .then(res => {
          const viewTreeData = findDataByParam('viewTree', true, res.data)
          this.viewTreeData = viewTreeData
        })
    },
    //获取信息概览信息
    getData () {
      let vm = this
      //信息概览
      vm.ifLoad = true
      vm.$api.tmp
        .getPowerDeviation(vm.selectedMeasure.measureId)
        .then(resArr => {
          if (resArr.success) {
            vm.ifLoad = false
            vm.tableData = [] //供电偏差
            let tableData = []
            resArr.data.lineVoltage.forEach(item => {
              tableData.push(item)
            })
            resArr.data.phaseVoltage.forEach(item => {
              tableData.push(item)
            })
            tableData.push(resArr.data.frquency)
            tableData.forEach((item, i) => {
              if (i < tableData.length - 1) {
                item.voltage = '相电压'
                if (resArr.data.lineVoltage.length > 0) {
                  if (i < resArr.data.lineVoltage.length) {
                    item.voltage = '线电压'
                  }
                }
                console.log(isUndefined(item.realTime))
                item.realTime = isUndefined(item.realTime) || item.realTime == '-' ? '-' : item.realTime + 'V'
                item.max = isUndefined(item.max) || item.max == '-' ? '-' : item.max + 'V'
                item.min = isUndefined(item.min) || item.min == '-' ? '-' : item.min + 'V'
              } else {
                item.voltage = '频率'
                item.realTime = isUndefined(item.realTime) || item.realTime == "-" ? '-' : item.realTime + 'Hz'
                item.max = isUndefined(item.max) || item.max == "-" ? '-' : item.max + 'Hz'
                item.min = isUndefined(item.min) || item.min == "-" ? '-' : item.min + 'Hz'
              }
              item.deviation = isUndefined(item.deviation) || item.deviation + '%'
            })
            vm.frquencyPass = resArr.data.frquencyPass
            vm.volatgePass = resArr.data.volatgePass
            vm.tableData = tableData
            let frequency = {
              series: [
                {
                  data: [],
                  name: '频率',
                  type: 'line',
                  smooth: true
                }
              ],
              title: ['频率'],
              xData: []
            }
          } else {
            vm.$message.error(resArr.msg)
          }
        })
        .catch(error => {
          vm.$message.error(error.msg)
        })
    },
    tabclick (e) {
      if (e == 'left') {
        this.topcontent = false
      } else {
        this.topcontent = true
      }
    },
    Btn () {
      let vm = this
      vm.tabShow = !vm.tabShow
      vm.getData()
    },
    //树默认点击第一条
    tabTreeDefault (e) {
      let vm = this
      vm.selectedMeasure = e
      vm.getData()
    },
    //树点击事件
    tabTreeClick (e) {
      let vm = this
      vm.selectedMeasure = e
      vm.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/eleDeviation.scss";
.ele-wrap {
  padding: 14px;
  box-sizing: border-box;
  height: 100%;
}
.person {
  height: 100%;
}
.grid-content {
  position: relative;
  height: 100%;
  background: #fff;
  color: rgba(24, 24, 24, 1);
  overflow: auto;
  border-radius: 4px;
}
.flexStyle {
  display: flex;
  height: 100%;
}
.grid-rightcontent {
  position: relative;
  height: 100%;
  //   background: #d5dadd;
  color: rgba(24, 24, 24, 1);
  display: flex;
  flex-flow: column;
}
.top {
  margin-bottom: 10px;
  background: #fff;
  width: 100%;
  overflow: hidden;
  border-radius: 4px;
}
.toptitle {
  background: #f0f3f4;
  color: rgba(24, 24, 24, 1);
  font-weight: bold;
  display: flex;
  padding: 5px;
  font-size: 16px;
}
.topall {
  display: flex;
}
.topright {
  display: flex;
  flex: 2;
  justify-content: center;
  align-items: center;
}
.topcontent {
  margin: 0.5%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  width: 80%;
  position: relative;
  border-radius: 4px;
  height: 85px;
  .titlebox {
    display: flex;
    width: 15%;
    align-items: center;
  }
}
.middle {
  margin-bottom: 10px;
  display: flex;
  height: calc(50% - 10px);
  flex-flow: column;
}
.middleleft {
  height: 242px;
}
.middleright {
  height: 242px;
}
.contentOne {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-size: 0.7rem;
  margin-left: 5%;
}
.content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 5%;
  span:nth-child(2) {
    margin-top: 10px;
    color: #111;
    font-size: 1.2rem;
    font-weight: bold;
  }
}
.bottom {
  display: flex;
  height: calc(100% - 50% + 10px);
  flex-flow: column;
}
.middletitleleft {
  background: #0197ee;
  color: #fff;
  font-weight: bold;
  display: flex;
  padding: 5px;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.middletitleright {
  background: #f0f3f4;
  color: rgba(24, 24, 24, 1);
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  // padding: 5px;
}
.middleleft {
  //   border: 1px solid #eee;
  background: #fff;
  height: 30vh;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.middleright {
  border: 1px solid #eee;
  background: #fff;
  height: 30vh;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.bottomleft {
  border: 1px solid #eee;
  background: #fff;
  height: 39vh;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
// ::v-deep .tabTree-wrap[data-v-bd1aa9c2] {
//   background: #fff;
//   height: 90.5%;
// }
.leftBottom {
  background: #d4dde1;
  position: absolute;
  top: 35%;
  left: 2%;
  line-height: 20px;
  height: 20px;
  cursor: pointer;
}
.rightbottom {
  background: #d4dde1;
  position: absolute;
  top: 35%;
  right: 2%;
  line-height: 20px;
  height: 20px;
  cursor: pointer;
}
</style>